import script from "./Grades.vue?vue&type=script&lang=ts&setup=true"
export * from "./Grades.vue?vue&type=script&lang=ts&setup=true"

import "./Grades.vue?vue&type=style&index=0&id=fb6c8ec4&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fb6c8ec4"]])

export default __exports__